import { useQuery } from "@tanstack/react-query";
import api from "../api/apiClient";
import { PaginatedTicketsResponse, Ticket } from "../types/modules/ticket.type";

export const useUnreadTicketsCount = (enabled: boolean = true) => {
    return useQuery({
        queryKey: ["unread-tickets-count"],
        queryFn: async () => {
            try {
                let totalUnread = 0;
                let page = 1;
                let hasMorePages = true;

                while (hasMorePages) {
                    const params = new URLSearchParams({
                        page: page.toString(),
                        limit: "100", 
                    });

                    const response = await api.get<PaginatedTicketsResponse>(
                        `/ticket?${params.toString()}`
                    );

                    const pageUnread = (response.data?.data || []).reduce((total: number, ticket: Ticket) => {
                        const count = ticket.unreadCount || 0;
                        return total + count;
                    }, 0);

                    totalUnread += pageUnread;
                    if (page >= response.data.totalPages) {
                        hasMorePages = false;
                    } else {
                        page++;
                    }
                }

                return totalUnread;
            } catch (error) {
                return 0;
            }
        },
        enabled: enabled,
        refetchInterval: 30000,
        staleTime: 10000,
    });
};
